import { API } from '~/data/api'
import type { StandardLikeObjectType } from '~/types/like'

export const useLikeService = () => {
  const interactionStore = useInteractionStore()

  async function getLikes(
    modelType: StandardLikeObjectType,
    objectId: number,
    limit?: number,
    after?: string
  ) {
    const response = await API.getLikes(modelType, objectId, limit, after)

    return response.data
  }

  async function getGroupPostingLikes(
    groupId: number,
    postingId: number,
    limit?: number,
    after?: string
  ) {
    const response = await API.getGroupPostingLikes(groupId, postingId, limit, after)

    return response.data
  }

  async function likeTrip(tripId: number) {
    const response = await API.createLike(`/trips/${tripId}/likes`)

    if (response) {
      interactionStore.likeItem('trips', tripId)
    }
  }

  async function unlikeTrip(tripId: number) {
    const deleteResponse = await API.deleteLike(`trips/${tripId}/likes`)

    if (!deleteResponse) return

    interactionStore.unlikeItem('trips', tripId)
  }

  async function likeTripPhoto(photoId: number) {
    const response = await API.createLike(`photos/${photoId}/likes`)

    if (response) {
      interactionStore.likeItem('tripPhotos', photoId)
    }
  }

  async function unlikeTripPhoto(photoId: number) {
    const deleteResponse = await API.deleteLike(`photos/${photoId}/likes`)

    if (!deleteResponse) return

    interactionStore.unlikeItem('tripPhotos', photoId)
  }

  async function likeSection(sectionId: number) {
    const response = await API.createLike(`/sections/${sectionId}/likes`)

    if (response) {
      interactionStore.likeItem('sections', sectionId)
    }
  }

  async function unlikeSection(sectionId: number) {
    const deleteResponse = await API.deleteLike(`sections/${sectionId}/likes`)

    if (!deleteResponse) return

    interactionStore.unlikeItem('sections', sectionId)
  }

  async function likePosting(postingId: number) {
    const response = await API.createLike(`/postings/${postingId}/likes`)

    if (response) {
      interactionStore.likeItem('postings', postingId)
    }
  }

  async function unlikePosting(postingId: number) {
    const deleteResponse = await API.deleteLike(`postings/${postingId}/likes`)

    if (!deleteResponse) return

    interactionStore.unlikeItem('postings', postingId)
  }

  async function likeGroupPosting(groupId: number, postingId: number) {
    const response = await API.likeGroupPosting(groupId, postingId)

    if (response) {
      interactionStore.likeItem('groupPostings', postingId)
    }

    return response.data
  }

  async function unlikeGroupPosting(groupId: number, postingId: number) {
    const deleteResponse = await API.unlikeGroupPosting(groupId, postingId)

    if (!deleteResponse) return

    interactionStore.unlikeItem('groupPostings', postingId)
  }

  async function likeBike(bikeId: number) {
    const response = await API.likeBike(bikeId)

    if (response) {
      interactionStore.likeItem('bikes', bikeId)
    }
  }

  async function unlikeBike(bikeId: number) {
    const deleteResponse = await API.unlikeBike(bikeId)

    if (!deleteResponse) return

    interactionStore.unlikeItem('bikes', bikeId)
  }

  async function likeHelmet(helmetId: number) {
    const response = await API.likeHelmet(helmetId)

    if (response) {
      interactionStore.likeItem('helmets', helmetId)
    }
  }

  async function unlikeHelmet(helmetId: number) {
    const deleteResponse = await API.unlikeHelmet(helmetId)

    if (!deleteResponse) return

    interactionStore.unlikeItem('helmets', helmetId)
  }

  async function likeIntercom(intercomId: number) {
    const response = await API.likeIntercom(intercomId)

    if (response) {
      interactionStore.likeItem('intercoms', intercomId)
    }
  }

  async function unlikeIntercom(intercomId: number) {
    const deleteResponse = await API.unlikeIntercom(intercomId)

    if (!deleteResponse) return

    interactionStore.unlikeItem('intercoms', intercomId)
  }

  return {
    getLikes,
    getGroupPostingLikes,
    likeTrip,
    unlikeTrip,
    likeTripPhoto,
    unlikeTripPhoto,
    likeSection,
    unlikeSection,
    likePosting,
    unlikePosting,
    likeGroupPosting,
    unlikeGroupPosting,
    likeBike,
    unlikeBike,
    likeHelmet,
    unlikeHelmet,
    likeIntercom,
    unlikeIntercom
  }
}
